<div class="modal fade" id="publishPostModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content rounded-4 mx-2 modal-fixed p-3">

            <button class="close-btn" (click)="close()">&times;</button>

            <div class="modal-header-custom p-3 border-bottom">
                <div class="company-header d-flex align-items-center gap-2">
                    <div
                        class="company-logo d-flex align-items-center justify-content-center bdr-black rounded-4 me-2 p-2">
                        <img [src]="'https://www.skeinforce.com:8080/images/company_logo/' + CompanyPost.PseudoCompanyLogoName"
                            class="img-fluid comp-logo" alt="{{CompanyPost.CompanyName}}">
                    </div>
                    <div>
                        <div class="syne-text fw-semibold fs-20">
                            {{ CompanyPost.CompanyName }}
                        </div>
                        <div class="fs-16">
                            {{ 'publish_post' | translate }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-2">
                <div class="text-muted ms-2 fs-20">
                    {{ 'what_do_you_want_to_talk' | translate }}
                </div>
            </div>

            <div class="modal-tabs border-bottom px-3 mt-2">
                <ul class="nav nav-tabs syne-text border-0 mx-4 justify-content-between">

                    <li class="nav-item">
                        <button class="nav-link" [class.active]="selectedPostLang === 'en'"
                            [class.error-tab]="selectedPostLang !== 'en' && (langErrors['en']?.desc)"
                            (click)="onChangeLanguage('en')">
                            {{ 'english' | translate }}
                        </button>
                    </li>

                    <li class="nav-item">
                        <button class="nav-link" [class.active]="selectedPostLang === 'it'"
                            (click)="onChangeLanguage('it')">
                            {{ 'italian' | translate }}
                        </button>
                    </li>

                    <li class="nav-item">
                        <button class="nav-link" [class.active]="selectedPostLang === 'fr'"
                            (click)="onChangeLanguage('fr')">
                            {{ 'french' | translate }}
                        </button>
                    </li>

                    <li class="nav-item">
                        <button class="nav-link" [class.active]="selectedPostLang === 'es'"
                            (click)="onChangeLanguage('es')">
                            {{ 'spanish' | translate }}
                        </button>
                    </li>

                    <li class="nav-item">
                        <button class="nav-link" [class.active]="selectedPostLang === 'de'"
                            (click)="onChangeLanguage('de')">
                            {{ 'german' | translate }}
                        </button>
                    </li>

                </ul>
            </div>

            <div class="modal-body-scroll p-3">

                <div class="postEditor">
                    <div class="text-danger ms-2 fs-15"
                        *ngIf="selectedLangData && langErrors[selectedLangData.Language]?.desc">
                        {{ 'post_text_required' | translate }}
                    </div>
                    <app-ssr-rich-text-editor [value]="selectedLangData.Description" [isPost]="true"
                        (valueChange)="onContentChange($event)" (exit)="onEditorExit($event)">
                    </app-ssr-rich-text-editor>
                </div>

                <div class="mt-3">
                    <div class="media-preview mt-3" *ngIf="CompanyPost.PostImage && CompanyPost.PostImage.Url">
                        <div class="image-box">
                            <span class="remove-btn" (click)="deleteMedia(CompanyPost.PostImage, 'image')"
                                onkeyup="">×</span>
                            <img [src]="CompanyPost.PostImage.Url" alt="Post" />
                        </div>
                    </div>
                </div>

                <div class="pdf-preview d-flex justify-content-center mt-3"
                    *ngIf="CompanyPost.PostPdf && CompanyPost.PostPdf.Url">

                    <div class="d-flex pdf-container position-absolute align-items-center border rounded-3 p-3 mb-3">
                        <span class="remove-btn" (click)="deleteMedia(CompanyPost.PostPdf, 'pdf')" onkeyup="">×</span>
                        <div class="icon-box d-flex align-items-center justify-content-center bg-light rounded me-2">
                            <img [src]="'assets/images/files/pdf.png'" alt="PDF" class="icon-img">
                        </div>

                        <div class="pdf-name flex-grow-1" [title]="CompanyPost.PostPdf.OriginalName">
                            {{ CompanyPost.PostPdf.OriginalName }}
                        </div>

                        <button class="btn btn-link p-0 ms-2" [title]="('preview' | translate)" (click)="previewFile()">
                            <i class="fa-solid fa-eye"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="modal-footer-custom p-2 border-top">
                <div class="d-flex">
                    <div #emojiWrapper class="emoji-wrapper">
                        <button class="btn btn-sm border-0" (click)="togglePicker($event)">
                            <i class="icon skf-smiley"></i>
                        </button>

                        <div class="emoji-popup" [hidden]="!showPicker">
                            <div #pickerContainer></div>
                        </div>
                    </div>

                    <button class="btn btn-sm border-0" (click)="triggerImageUpload()" onkeyup=""
                        [hidden]="CompanyPost.PostImage && CompanyPost.PostImage.Url">
                        <i class="icon skf-photo-plus"></i>
                    </button>

                    <button class="btn btn-sm border-0" (click)="triggerPdfUpload()" onkeyup=""
                        [hidden]="CompanyPost.PostPdf && CompanyPost.PostPdf.Url">
                        <i class="icon skf-plus"></i>
                    </button>

                    <input id="" type="file" hidden #imageInput accept="image/*"
                        (change)="onFileUpload($event, 'image')" />
                    <input id="" type="file" hidden #pdfInput accept=".pdf" (change)="onFileUpload($event, 'pdf')" />
                </div>

                <div class="divider"></div>

                <div class="text-end mt-3 me-3">
                    <button class="btn btn-primary rounded-pill px-4 py-2" (click)="onPublishPost()"
                        [disabled]="!canPublish()">
                        <i class="skf-send me-1"></i>
                        {{ 'public' | translate }}
                    </button>
                </div>

            </div>

        </div>
    </div>
</div>

<div class="pdf-overlay d-flex justify-content-center align-items-center" *ngIf="showPdfModal">
    <div class="modal-card bg-white rounded shadow position-relative">
        <button class="btn btn-light position-absolute top-0 end-0 m-2" (click)="closePdfModal()">
            &times;
        </button>
        <iframe *ngIf="pdfUrl" [src]="pdfUrl" title="Product PDF preview" class="w-100 pdf-preview rounded"></iframe>
    </div>
</div>

<div class="modal fade post-media-confirm-modal" id="postConfirmModal" tabindex="-1" aria-hidden="true"
    data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered custom-modal">
        <div class="modal-content confirm-modal text-center rounded-4 p-4">
            <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
            <h5 class="modal-title my-2 mb-4">
                {{ 'confirm_delete_content' | translate}}
            </h5>
            <div class="d-flex justify-content-center syne-text gap-3 mt-2 mb-4">
                <button class="btn modal-btn-red" data-bs-dismiss="modal" (click)="onCancelConfirmModal()">
                    {{ 'go_back' | translate }}
                </button>
                <button class="btn modal-btn-blue syne-text" (click)="confirmDelete()" data-bs-dismiss="modal">
                    {{ 'proceed' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="PublishSuccessModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-4 rounded-4">
            <button type="button" class="btn-close ms-auto fs-15" data-bs-dismiss="modal"></button>

            <div class="mx-2 p-3">
                <div class="fw-medium text-center fs-32 syne-text mb-3">
                    {{ 'post_published_success' | translate }}
                </div>

                <div class="text-muted fs-16 text-center mb-1 pt-2 mx-auto">
                    {{ 'post_visibility_info' | translate }}
                </div>
                <button
                    class=" btn btn-sm fs-16 text-center border-0 mt-4 mb-3 mx-auto discover-text d-block mx-auto cursor-pointer"
                    (click)="goToCompanyPage()" onkeyup="">
                    {{ 'discover_now' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>